import { TeamMemberInviteGuestRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/team/invite-guest')({
  component: TeamMemberInviteGuestRoute,
});
